import type { InlineDiff, InlineDiffLine } from "@/lib/client/generated/TypeDefinitions.ts"

// Convert two plain-text versions into a minimal InlineDiff suitable for DiffComponent
export function buildInlineDiff(before: string, after: string): InlineDiff {
  const beforeLines = before ? before.split("\n") : []
  const afterLines = after ? after.split("\n") : []

  let oldOffset = 0
  let newOffset = 0

  const lines: InlineDiffLine[] = []

  // Deletions (before)
  beforeLines.forEach((text, idx) => {
    lines.push({
      className: "InlineDiffLine",
      text,
      type: "DELETED",
      oldLineNum: idx,
      newLineNum: null,
      oldFileOffset: oldOffset,
      newFileOffset: newOffset,
      syntax: null,
      deletes: null,
      inserts: null,
    })
    oldOffset += text.length + 1
  })

  // Additions (after)
  afterLines.forEach((text, idx) => {
    lines.push({
      className: "InlineDiffLine",
      text,
      type: "ADDED",
      oldLineNum: null,
      newLineNum: idx,
      oldFileOffset: oldOffset,
      newFileOffset: newOffset,
      syntax: null,
      deletes: null,
      inserts: null,
    })
    newOffset += text.length + 1
  })

  return {
    className: "InlineDiff",
    type: "TEXT",
    lines,
    hasFilteredFragments: false,
    lineEndingDiff: null,
    bomDiff: null,
    scopes: null,
  }
}
